/**
 * Domain of APP_THEME cookie shared with IDP
 */
export const THEME_COOKIE_DOMAIN = '.mf.gov.pl';

/**
 * Domain for APP_THEME cookie
 * @param hostname - hostname of the app
 * @returns THEME_COOKIE_DOMAIN when app runs on it or its subdomain,
 * undefined otherwise (e.g. localhost), because browser rejects cookie for not matching domain
 */
export const getThemeCookieDomain = (hostname: string = window.location.hostname): string | undefined => {
  const isOnSharedCookieDomain = hostname === THEME_COOKIE_DOMAIN.slice(1) || hostname.endsWith(THEME_COOKIE_DOMAIN);

  return isOnSharedCookieDomain ? THEME_COOKIE_DOMAIN : undefined;
};
